export default __webpack_public_path__ + "assets/icon-close.d3f6869c.webp";